function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21988"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17771",
    d: "M10 18a8 8 0 1 0-8-8 8 8 0 0 0 8 8zm3.707-9.293a1 1 0 1 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z",
    transform: "translate(2 2)",
    style: {
      fill: "#48bea2",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20006",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })));
};

export default SvgSuccess;